<template>
  <div class="page-move-section w-full">
    <div
      class="page-move prev w-full f-b f-gry"
      :class="{ 'is-show': !prev }"
      @click="goPrev"
    >
      {{ prevText }}
    </div>
    <div class="page-move next w-full f-b f-wh" @click="goNext">
      {{ nextText }}
    </div>
  </div>
</template>

<script>
export default {
  name: "PageMoveBtn",
  props: {
    prev: {
      type: Boolean,
      default: false,
    },
    backPressIsFunction: {
      type: Boolean,
      default: false,
    },
    prevText: {
      type: String,
      default: "이전",
    },
    nextText: {
      type: String,
      default: "다음",
    },
  },
  methods: {
    goPrev() {
      this.$emit("backpress");
    },
    goNext() {
      this.$emit("nextpress");
    },
  },
};
</script>
